import React from 'react'
import './LocalAid.css'
import Profile from '../../../assets/profile 2.png'
import relatives from '../../../assets/relative.png'
import requests from '../../../assets/requests.png'
import { useHistory } from 'react-router'
import { useTranslation } from "react-i18next";
import ShareHeader from '../../LoaclComponents/shareHeader/ShareHeader'

const LocalAid = () => {
    const { t } = useTranslation();
    let lng = JSON.parse(localStorage.getItem('language'))?.lang;
    let userLogin = JSON.parse(localStorage.getItem('userLogin'))
    const history = useHistory()
    const handleGoToMakeRequest = () => {
        history.push('/localAid/submit-request')
    }
    if (userLogin?.Results[0]?.person_id_flag==='2') {
        return (
        <div className='localAid_page_wraper' style={lng==='arab'? {direction:'rtl'}:null}>
            <ShareHeader pageName={t("Local Aid")} noShare={true}/>
            <div className='local_aid_page'>
                <button onClick={()=> history.push('/localAid/localAidProfile')} className='local_aid_btn'>
                    <img src={Profile} alt='profile_btn' className='local_aid_btn_img'/>
                    <span className='local_aid_btn_wraper'>
                        <span style={{flex:'9'}}>{t("Profile")}</span>
                        {lng==='arab'?
                        <i style={{flex:'1'}} className="fas fa-arrow-left"></i>:
                        <i style={{flex:'1'}} className="fas fa-arrow-right"></i>
                    }
                        
                    </span>
                </button>
                <button onClick={()=> history.push('/localAid/relatives')} className='local_aid_btn'>
                    <img src={relatives} alt='relatives_btn' className='local_aid_btn_img'/>
                    <span className='local_aid_btn_wraper'>
                        <span style={{flex:'9'}}>{t("Relatives")}</span>
                        {lng==='arab'?
                        <i style={{flex:'1'}} className="fas fa-arrow-left"></i>:
                        <i style={{flex:'1'}} className="fas fa-arrow-right"></i>
                    }
                    </span>
                </button>
                <button onClick={()=> history.push('/localAid/requests')} className='local_aid_btn'>
                    <img src={requests} alt='profile_btn' className='local_aid_btn_img'/>
                    <span className='local_aid_btn_wraper'>
                        <span style={{flex:'9'}}>{t("Requests")}</span>
                        {lng==='arab'?
                        <i style={{flex:'1'}} className="fas fa-arrow-left"></i>:
                        <i style={{flex:'1'}} className="fas fa-arrow-right"></i>
                    }
                    </span>
                </button>
            </div>
            <button onClick={handleGoToMakeRequest} style={{ alignSelf:'center'}} type='button' className='local_aid_submit'>
                <span style={{flex:'25'}}>{t("Submit a request")}</span>
                {lng==='arab'?
                <i className="fas fa-arrow-left"></i> :
                <i className="fas fa-arrow-right"></i>
            }
            </button>
        </div>
    )
    } else {
        window.location.replace("/profile");
    }
    
}

export default LocalAid